import { v7 as uuid } from "uuid"
import { db } from "../../mp-database"
import { manualAddStudent } from "./manualAddStudent"
import { getExternalStudentId } from "../helpers/getExternalStudentId"
import {
  GenerateFormData,
  ImportParams,
  ImportableCollection,
  UploadRecord
} from "../types"

export const getLoginLettersData = async (
  collection: ImportableCollection,
  importedRecords: UploadRecord[],
  duplicates: any[],
  { includeDuplicates }: GenerateFormData,
  { districtId, schoolId }: ImportParams
): Promise<UploadRecord[]> => {
  let usersData: UploadRecord[] = []

  if (includeDuplicates) {
    // Only consider duplicates for current school and district.
    const localDuplicates = duplicates.filter(
      dup => dup.school === schoolId && dup.schoolDistrict === districtId
    )
    importedRecords.forEach(record => {
      const found = duplicates.find(dup => {
        if (
          ((record.email && dup.email === record.email) ||
            (record.username && dup.username === record.username)) &&
          (dup.schoolDistrict !== districtId || dup.school !== schoolId)
        ) {
          return dup
        }
      })
      if (!found) {
        usersData.push(record)
      }
    })

    for (let i = 0; i < localDuplicates.length; i++) {
      const { id, email, username } = localDuplicates[i]
      const record = usersData.find(
        rec =>
          (rec.email && rec.email === email) ||
          (rec.username && rec.username === username)
      )

      const sendInvite = record?.sendInvite?.toLowerCase()
      const externalStudentId = record && getExternalStudentId(record)

      if (record && sendInvite === "no") {
        const updateData: any = {}

        if (username !== record.username && record.username) {
          updateData.username = record.username
        }
        if (email !== record.email && record.email) {
          updateData.email = record.email
        }
        if (externalStudentId) {
          updateData.externalStudentId = externalStudentId
        }

        if (record.firstName) {
          updateData.firstName = record.firstName
          updateData.firstName_lower = record.firstName.toLowerCase()
        }
        if (record.lastName) {
          updateData.lastName = record.lastName
          updateData.lastName_lower = record.lastName.toLowerCase()
        }
        if (updateData.firstName && updateData.lastName) {
          updateData.fullName =
            `${updateData.firstName} ${updateData.lastName}`.trim()
          updateData.fullname_lower = updateData.fullName.toLowerCase().trim()
        }

        if (Object.keys(updateData).length) {
          await db
            .collection(collection)
            .doc(id)
            .update({
              ...updateData
            })
        }

        record.password = await manualAddStudent(id, record.password)
      }

      if (record && !record.password && sendInvite === "yes") {
        const usernameOrEmailUpdate: any = {}

        if (username !== record.username && record.username) {
          usernameOrEmailUpdate.username = record.username
        }
        if (email !== record.email && record.email) {
          usernameOrEmailUpdate.email = record.email
        }
        if (externalStudentId) {
          usernameOrEmailUpdate.externalStudentId = externalStudentId
        }

        if (Object.keys(usernameOrEmailUpdate).length) {
          await db.collection(collection).doc(id).update(usernameOrEmailUpdate)
        }

        // REVIEW: Can we do batch here too?
        const inviteId = uuid()
        const inviteRef = db.collection("userInvites").doc(inviteId)
        const time = Date.now()
        await inviteRef.set({
          id: inviteId,
          userId: id,
          createdDate: time,
          expirationDate: time + 259200000, // 3 days
          firstName: record.firstName,
          lastName: record.lastName,
          email: record.email
        })
      }
    }
  } else {
    if (duplicates.length) {
      importedRecords.forEach(record => {
        const found = duplicates.find(
          dup =>
            (record.email && dup.email === record.email) ||
            (record.username && dup.username === record.username)
        )
        if (!found) {
          usersData.push(record)
        }
      })
    } else {
      usersData = importedRecords
    }
  }

  return usersData
}
